import { useEffect } from 'react';
import { LeadSource } from '../../models/application.model';
import InlineServiceForm from './inline-service-form.container';

const NOINDEX_CONTENT = 'noindex, nofollow';

export default function InlineServiceFormPage({ leadSource }: { leadSource: LeadSource }) {
  useEffect(() => {
    const metaNames = ['robots', 'googlebot'] as const;
    const snapshots: { el: HTMLMetaElement; previousContent: string | null; created: boolean }[] = [];

    for (const name of metaNames) {
      let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
      const created = !el;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      const previousContent = el.getAttribute('content');
      el.setAttribute('content', NOINDEX_CONTENT);
      snapshots.push({ el, previousContent, created });
    }

    return () => {
      for (const { el, previousContent, created } of snapshots) {
        if (created) {
          el.remove();
        } else if (previousContent !== null) {
          el.setAttribute('content', previousContent);
        } else {
          el.removeAttribute('content');
        }
      }
    };
  }, []);

  return (
    <>
      <section id="banner">
        <div className="banner-overlay">
          <h1>Service Form</h1>
        </div>
      </section>
      <InlineServiceForm leadSource={leadSource} />
    </>
  );
}
